export const descriptors = [
  'rookie',
  'washed-up',
  'retired',
  'unhinged',
  'slick',
  'incompetent',
  'psychic',
  'arrogant',
  'overzealous',
  'clumsy'
]

export const species = [
  'grizzly bear',
  'polar bear',
  'panda',
  'black bear',
  'sun bear',
  'honey badger',
  'sloth bear',
  'spectacled bear',
  'brown bear',
  'beaver'
]

export const roles = [
  'muscle',
  'brains',
  'driver',
  'hacker',
  'thief',
  'face',
  'gymnast',
  'alcoholic',
  'capitalist',
  'daredevil',
  'engineer',
  'stoner'
]

export const skills = {
  'grizzly bear': 'Terrify',
  'polar bear': 'Swim',
  'panda': 'Charm',
  'black bear': 'Climb',
  'sun bear': 'Sense Honey',
  'honey badger': 'Carnage',
  'sloth bear': 'Stealth',
  'spectacled bear': 'Enhanced Sight',
  'brown bear': 'Fish',
  'beaver': 'Gnaw'
}

export const flavours = {
    'grizzly bear': 'Scare them into submission',
    'polar bear': 'Your aquatic ability astounds all',
    'panda': 'Your inherent charisma bends others to your will',
    'black bear': 'For you, every wall is a ladder',
    'sun bear': 'Honey fears you',
    'honey badger': 'Oh god, there\'s so much blood...',
    'sloth bear': 'You can sneak up on shadows',
    'spectacled bear': 'Awesome acuity',
    'brown bear': 'Water born creatures love to hate you',
    'beaver': 'Get that wood out of the way'
}
